import { PreviewModes } from '../../constants';

export default function getPublishedStateHeader(previewMode?: string | null) {
  return PreviewModes.PREVIEW === previewMode ? 'Draft' : 'Published';
}
